import Axios from 'axios'
import * as React from 'react'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {AttachmentInfo} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {getMapService} from '../../core/reducers/map'
import {DrawType} from '../../core/enums/DrawType'
import {DrawSource} from '../../core/enums/DrawSource'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {Point} from '../../core/models'
import {CsSelector} from '../../core/components/Controls/CsSelector'

enum CS {
  GEO = 1,
  WEB = 2,
  BG2005 = 4,
  BG2005CAD = 5,
  BG703 = 6,
  BG705 = 7,
  BG707 = 8,
  BG709 = 9,
  BG3024 = 14,
  BG3027 = 15,
  BG50324 = 10,
  BG50327 = 11,
  BG50621 = 12,
  BG50627 = 13
}

interface Props {}

interface State {
  loading: boolean
  file?: AttachmentInfo
  afterSuccess: boolean
  error: string
  CoordsX: any
  CoordsY: any
  TranslatedX: any
  TranslatedY: any
  TranslatedX2005: any
  TranslatedY2005: any
  dataCS: CoordinateSystem
  p: any
}

export class Crosses extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      error: '',
      CoordsX: '',
      CoordsY: '',
      TranslatedX: '',
      TranslatedY: '',
      TranslatedX2005: '',
      TranslatedY2005: '',
      dataCS: CoordinateSystem.BG_705,
      p: ''
    }
  }
  getCS(cs: CoordinateSystem): number {
    switch (cs) {
      case CoordinateSystem.BG_703:
        return CS.BG703
      case CoordinateSystem.BG_705:
        return CS.BG705
      case CoordinateSystem.BG_707:
        return CS.BG707
      case CoordinateSystem.BG_709:
        return CS.BG709
      case CoordinateSystem.GEOGRAPHIC:
        return CS.GEO
      case CoordinateSystem.BGS2005:
        return CS.BG2005
      case CoordinateSystem.BG2005CAD:
        return CS.BG2005CAD
      case CoordinateSystem.BG_3024:
        return CS.BG3024
      case CoordinateSystem.BG_3027:
        return CS.BG3027
      case CoordinateSystem.BG50324:
        return CS.BG50324
      case CoordinateSystem.BG50327:
        return CS.BG50327
      case CoordinateSystem.BG50621:
        return CS.BG50621
      case CoordinateSystem.BG50627:
        return CS.BG50627
      default:
        return CS.WEB
    }
  }

  getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={this.state.dataCS}
        onChange={s => this.setState({...this.state, error: '', dataCS: s})}
        className="form-control"
      />
    )
  }

  getResponseX = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.CoordsX}
          onClick={() => {
            navigator.clipboard.writeText(this.state.CoordsX)
          }}
          readOnly
        ></input>
      </div>
    )
  }
  getResponseY = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.CoordsY}
          onClick={() => {
            navigator.clipboard.writeText(this.state.CoordsY)
          }}
          readOnly
        ></input>
      </div>
    )
  }
  getTransX = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input className="form-control" style={{margin: '0 10px 0 0'}} value={this.state.TranslatedX} readOnly></input>
      </div>
    )
  }
  getTransY = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input className="form-control" style={{margin: '0 10px 0 0'}} value={this.state.TranslatedY} readOnly></input>
      </div>
    )
  }
  getTransX2005 = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.TranslatedX2005}
          readOnly
        ></input>
      </div>
    )
  }
  getTransY2005 = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.TranslatedY2005}
          readOnly
        ></input>
      </div>
    )
  }
  activatePartGeometrySetter() {
    getMapService().drawing.activateDraw(
      DrawType.Point,
      DrawSource.Edit,
      () => {},
      f => {
        const cs = this.getCS(this.state.dataCS)
        const data = JSON.stringify({
          Coordinates: [f.getGeometry().getCoordinates()],
          DestinationCS: cs
        })

        const cfg = {
          method: 'post',
          maxBodyLength: Infinity,
          url: config.getConfig().urls.xyApiUrl + '/BgTrans/TransPointsRoundedWebMercator',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        }

        Axios.request(cfg)
          .then(response => {
            this.setState({...this.state, CoordsX: response.data[0][0], error: ''})
            this.setState({...this.state, CoordsY: response.data[0][1], error: ''})
            const point = new Point(response.data[0])
            this.setState({...this.state, p: point, error: ''})

            getMapService().drawing.flash([point])

            Axios.post(config.getConfig().urls.xyApiUrl + '/BgTrans/TransPoints', {
              Coordinates: [response.data[0]],
              DestinationZone: 9,
              SourceCS: 2,
              DestinationCS: cs
            })
              .then(r => {
                this.setState({...this.state, TranslatedX: r.data[0][0], error: ''})
                this.setState({...this.state, TranslatedY: r.data[0][1], error: ''})
              })
              .catch(e => {
                console.log(e)
              })
            Axios.post(config.getConfig().urls.xyApiUrl + '/BgTrans/TransPoints', {
              Coordinates: [response.data[0]],
              DestinationZone: 9,
              SourceCS: 2,
              DestinationCS: 5
            })
              .then(r => {
                this.setState({...this.state, TranslatedX2005: r.data[0][0], error: ''})
                this.setState({...this.state, TranslatedY2005: r.data[0][1], error: ''})
              })
              .catch(e => {
                console.log(e)
              })
          })
          .catch(error => {
            console.log(error)
          })
      }
    )
  }

  getMapControl = () => {
    return (
      <button
        type="button"
        className="button"
        title="Изчертай на картата"
        onClick={() => this.activatePartGeometrySetter()}
      >
        <i className="fas fa-crosshairs" />
      </button>
    )
  }

  flashOnMap = () => {
    return (
      <button
        type="button"
        // style={buttonStyle}
        className="button"
        title="Покажи отново"
        onClick={() => getMapService().drawing.flash([this.state.p])}
      >
        <i className="fas fa-crosshairs" />
      </button>
    )
  }
  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }

  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>
            {this.getContainer(this.getProjectionSelector(), 'Координатна система', `10px 0px`)}
            {this.getContainer(this.getResponseX(), 'X', `10px 0px`)}
            {this.getContainer(this.getResponseY(), 'Y', `10px 0px`)}
            {this.getContainer(this.getTransX(), 'X ' + this.state.dataCS, `10px 0px`)}
            {this.getContainer(this.getTransY(), 'Y ' + this.state.dataCS, `10px 0px`)}
            {this.getContainer(this.getTransX2005(), 'X (2005 cad)', `10px 0px`)}
            {this.getContainer(this.getTransY2005(), 'Y (2005 cad)', `10px 0px`)}
            {this.getContainer(this.getMapControl(), 'Отбележи на картата', `10px 0px`)}
            {this.getContainer(this.flashOnMap(), 'Покажи отново', `10px 0px`)}
          </div>
        }
      </div>
    )
  }
}
